"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProducerEmailName = void 0;
var ProducerEmailName;
(function (ProducerEmailName) {
    ProducerEmailName["invitationEmail"] = "invitationEmail";
    ProducerEmailName["reminderEmail"] = "reminderEmail";
    ProducerEmailName["secondReminderEmail"] = "secondReminderEmail";
    ProducerEmailName["firstEventReminderEmail"] = "firstEventReminderEmail";
    ProducerEmailName["secondEventReminderEmail"] = "secondEventReminderEmail";
    ProducerEmailName["eventStartReminderEmail"] = "eventStartReminderEmail";
    ProducerEmailName["clipReadyReminderEmail"] = "clipReadyReminderEmail";
    ProducerEmailName["secondClipReadyReminderEmail"] = "secondClipReadyReminderEmail";
    ProducerEmailName["thirdClipReadyReminderEmail"] = "thirdClipReadyReminderEmail";
    ProducerEmailName["firstSelfClipReminderEmail"] = "firstSelfClipReminderEmail";
    ProducerEmailName["secondSelfClipReminderEmail"] = "secondSelfClipReminderEmail";
    ProducerEmailName["thirdSelfClipReminderEmail"] = "thirdSelfClipReminderEmail";
})(ProducerEmailName = exports.ProducerEmailName || (exports.ProducerEmailName = {}));
//# sourceMappingURL=producer-email-names.js.map